import React from "react";

import { useWindowDimensions } from "../../../hooks/window";
import Profit from "./Profit";
import NetProfit from "./NetProfit";
import SellInfo from "../SellItem/SellInfo";
import SourcedInfo from "../SourcedItem/SourcedInfo";
import Info from "../ItemProduct/Info";

const RequestInfo = ({ item, profitPrices, quote }) => {
  const { isMobile } = useWindowDimensions();

  const isSellRequest = item?.request_type === "sell";

  if (isMobile) {
    return (
      <div className="profit-mobile">
        <Info label="Profit">
          <Profit {...profitPrices} type={isSellRequest ? "sell" : "order"} />
        </Info>
        <Info label="Net Profit">
          <NetProfit
            {...profitPrices}
            type={isSellRequest ? "sell" : "order"}
            listing={quote?.listing}
            quote={quote}
          />
        </Info>
      </div>
    );
  }

  const InfoComponent = isSellRequest ? SellInfo : SourcedInfo;

  return (
    <InfoComponent item={item} isHeader>
      {isSellRequest ? (
        <>
          <Info label="Profit">
            <Profit {...profitPrices} type="sell" />
          </Info>
          <Info label="Net Profit">
            <NetProfit
              {...profitPrices}
              type="sell"
              listing={quote?.listing}
              quote={quote}
            />
          </Info>
        </>
      ) : (
        <div style={{ display: "flex", gap: "20px", paddingLeft: "0px" }}>
          <Info label="Profit">
            <Profit {...profitPrices} type="order" />
          </Info>
          <Info label="Net Profit">
            <NetProfit
              {...profitPrices}
              type="order"
              listing={quote?.listing}
              quote={quote}
            />
          </Info>
        </div>
      )}
    </InfoComponent>
  );
};

export default RequestInfo;
